module.exports = __webpack_public_path__ + "static/media/chocopiedras3.ad427c49.JPG";